import { render, staticRenderFns } from "./SSOProcessing.vue?vue&type=template&id=81822bca&"
import script from "./SSOProcessing.vue?vue&type=script&lang=js&"
export * from "./SSOProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports